/**
 * 雨课堂网页版登录界面
*/
import 'style/style.scss'
import 'style/_iconfont.scss'
import 'pages/login/login.scss'

// 解决低版本数组接口兼容等ES6
import "@babel/polyfill";

// 设置zepto CSRFToken
import zeptoHttp from 'zepto-http'
zeptoHttp()

import {loadScript} from 'utils'
import request from 'request2'
var TCaptchaUrl = "https://turing.captcha.qcloud.com/TCaptcha.js"
loadScript(TCaptchaUrl)

let isEn = false

let lng = Cookies.get('django_language') || 'zh-cn';
lng = lng === 'zh-cn' ? 'zh_CN' : 'en';
isEn = lng == 'en' ? true : false

var hcaptchaUrl = `https://js.hcaptcha.com/1/api.js?hl=${isEn ? 'en' : 'zh-CN'}`
loadScript(hcaptchaUrl, ['async', 'defer'])

// 日活上报
import dailyReport from 'daily-report'

// template
import loginTpl from './login.html'
import loginTplEn from './login_en.html'
import loginTplThu from './login_thu.html'
import loginTplThuEn from './login_thu_en.html'
import Api from 'api'
import socketHost from 'socket-host'
import JsEncrypt from "jsencrypt";

import Cookies from 'js-cookie'

let publicKey = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQBaPX7crEH6/jS4hRD7lZrsFRIdfwEhH30onFnrnWxiRATzP9WEneXJEZHopmzudkNS5bDp51SCnBUGGgfL/sUUrlrhV2xnTSe1jRl924ejV5rkVkiii85jp9G8eJrJN6klHs0PfYfp4EVJ8688qpi5iETtg+q4ITocyEyD1+7wIDAQAB-----END PUBLIC KEY-----'
let encryptor = new JsEncrypt();
encryptor.setPublicKey(publicKey);
// 雨课堂首页组件
// import Rainpc from 'pages/rainpc/rainpc'

let qrCode = ''
// 记录请求二维码的时间 防刷
let requestQRTimer = null;

function getPlatformKey() {
    let key = 'rain';
    let host = {
        'www.yuketang.cn': 'rain',
        'b.yuketang.cn': 'thunder',
        'pro.yuketang.cn': 'thu',
        'changjiang.yuketang.cn': 'changjiang',
        'g.yuketang.cn': 'g',
        'huanghe.yuketang.cn': 'huanghe',
        'rain.gdufemooc.cn': 'guangcai',
        'www.yudou.cn': 'yudou',

        // '127.0.0.1:8080' : 'yudou'
    }

    key = host[location.host] || 'rain';
    //console.log(location.host,key)
    return key;
}
let serverInfo = {
    'rain': {
        server: 'https://www.yuketang.cn/web',
        label: '雨课堂',
        label_en: 'RainClassroom'
    },
    'thu': {
        server: 'https://pro.yuketang.cn/web',
        label: '荷塘雨课堂',
        label_en: 'Hetang'
    },
    'changjiang': {
        server: 'https://changjiang.yuketang.cn/web',
        label: '长江雨课堂',
        label_en: 'Changjiang',
    },
    'huanghe': {
        server: 'https://huanghe.yuketang.cn/web',
        label: '黄河雨课堂',
        label_en: 'Huanghe'
    },
    'guangcai': {
        server: 'https://rain.gdufemooc.cn/web',
        //server: '127.0.0.1:8080/web',
        label: '广财雨课堂',
        label_en: 'Guangcai'
    },
    'yudou': {
        server: 'https://www.yudou.cn/web',
        label: '雨豆',
        label_en: 'Yudou'
    }
}
let hostKey =  getPlatformKey()
let hostInfo = {
    'thu': {
        title: '荷塘',
        en: 'Lotus Pond',
        online_url: 'https://qn-sfe.yuketang.cn/RainClassroom_4.4.0.2663_hetang_board.exe',
        offline_url: 'https://qn-sfe.yuketang.cn/RainClassroom_Full_4.4.0.2663_hetang_board.exe',
        history_url: 'https://qn-sfe.yuketang.cn/RainClassroom_4.1.0.893_hetang_board.exe',
        history_url2: 'https://qn-sfe.yuketang.cn/RainClassroom_4.3.0.2006_hetang_board.exe',
        online_size: 48,
        offline_size: 230,
        history_size: 56,
        history_size2: 30,
        version: '4.4.0.2663',
        update: '2020.12.22',

    },
    'changjiang': {
        title: '长江',
        en: 'Changjiang',
        online_url: 'https://qn-sfe.yuketang.cn/RainClassroom_4.3.0.2006_changjiang.exe',
        offline_url: 'https://qn-sfe.yuketang.cn/RainClassroom_Full_4.3.0.2006_changjiang.exe',
        history_url: 'https://qn-sfe.yuketang.cn/RainClassroom_4.1.0.893_changjiang.exe',
        online_size: 27,
        offline_size: 209,
        history_size: 54,
        version: '4.3.0.2006',
        update: '2020.09.09'
    },
    'huanghe': {
        title: '黄河',
        en: 'Huanghe',
        online_url: 'https://qn-sfe.yuketang.cn/RainClassroom_4.3.0.2006_huanghe.exe',
        offline_url: 'https://qn-sfe.yuketang.cn/RainClassroom_Full_4.3.0.2006_huanghe.exe',
        history_url: 'https://qn-sfe.yuketang.cn/RainClassroom_4.1.0.893_huanghe.exe',
        online_size: 27,
        offline_size: 209,
        history_size: 54,
        version: '4.3.0.2006',
        update: '2020.09.09'
    }
}

let rainHost = ['rain', 'thunder', 'g','guangcai','yudou']
if(rainHost.includes(hostKey)){
    $('body').addClass('body_bg')
    $('body').append(isEn ? loginTplEn : loginTpl);
}else {
    $('body').append(isEn ? loginTplThuEn : loginTplThu);
    setHostInfo()
}
setServerInfo()
function setHostInfo(){
    if(hostKey !== 'thu'){
        $('.download_btn_box.nothu').show()
        $('.beta').hide()
    }else {
        $('.download_btn_box.thu').show()
    }
    $('.logo').addClass(hostKey)
    $('.J_login').addClass('login_'+hostKey)
    $('.J_host').html(isEn ? hostInfo[hostKey].en : hostInfo[hostKey].title)
    $('.J_online').attr('href', hostInfo[hostKey].online_url)
    $('.J_offline').attr('href', hostInfo[hostKey].offline_url)
    $('.J_online_history').attr('href', hostInfo[hostKey].history_url)
    $('.J_online_history2').attr('href', hostInfo[hostKey].history_url2)
    $('.J_online_size').html(hostInfo[hostKey].online_size)
    $('.J_offline_size').html(hostInfo[hostKey].offline_size)
    $('.J_online_history_size').html(hostInfo[hostKey].history_size)
    $('.J_online_history_size2').html(hostInfo[hostKey].history_size2)
    $('.J_version').html(hostInfo[hostKey].version)
    $('.J_update').html(hostInfo[hostKey].update)
    $('.J_wechat').html(hostInfo[hostKey].title)
    $('.J_version_big').html('V'+hostInfo[hostKey].version.substring(0, 3))
    if(hostKey == 'thu'){
        $('.pic_author').show()
        $('.thu_board').show()
    }
}

function setServerInfo(key){
    let keyResult = key ? key : hostKey
    keyResult = serverInfo[keyResult] ? keyResult : 'rain'
    $('.current-server .logo').attr('class', 'logo')
    $('.current-server .logo').addClass(keyResult)
    $('.current-server .server').html(isEn ? serverInfo[keyResult].label_en : serverInfo[keyResult].label)
    $('.server-item .iconfont').removeClass('checked')
    $('.server-item[data-server="' + keyResult +'"] .iconfont').addClass('checked')
    $('.J_host0').html(isEn ? serverInfo[keyResult].label_en : serverInfo[keyResult].label)
    if(keyResult == 'guangcai'){ //广财
        $('.server-wrapper').addClass(keyResult)
        $('.L_title .logo').addClass(keyResult)
        $('.logo .plat_logo').attr('src','https://qn-sfe.yuketang.cn/o_1f2ob2sp2aa75h01t3j9fp1q5u9.png')
        $('.language').hide();
        $('.logo-info .logo').remove();
        $('.copyright .school_name').html('广东财经大学')
        $('.download-entry').hide();
    }
    if(keyResult == 'yudou'){ //未央
        $('.server-wrapper').addClass(keyResult)
        $('.L_title .logo').addClass(keyResult)
        $('.logo .plat_logo').attr('src','https://qn-sfe.yuketang.cn/o_1go7vsgch1g9o1pt7o2o12najn29.png')
        $('.language').hide();
        $('.J_host0').html('雨豆');
        $('.J_host_text').html('数字化教学解决方案');
        $('.logo-info .logo').remove();
        $('.footer-inner .beian').html('京ICP备14019655号-16');
        $('.footer-inner .beianimg').remove();
        $('.footer-inner .line').remove();
        $('.download-entry').hide();
        window.document.title = '雨豆网页版-登录';
    }
}

// 服务器切换
$('body').on('click', '.server-item', function()  {
    let key = $(this).attr('data-server')
    setServerInfo(key)
    $('.server-list').hide()
    // setTimeout(() => {
        location.href = serverInfo[key].server
    // }, 500);
})

$('.fetch-btn').click(fetchMa)

function fetchMa(){
    $('.logma').hide()
    $('.load-fail').hide()
    $('.loading-icon').show()

    let now = new Date().getTime();
    let lastTimer = requestQRTimer || 0;
    let duration = (now - lastTimer)/1000;

    // 30s内禁止重复发请求
    if(duration < 30) {
        return this;
    }

    exampleSocket.send(JSON.stringify({
        'op':"requestlogin",
        'role': "web",
        "version": 1.4,
        "type": "qrcode",
        "from": "web"
        }
    ));

    // 记录请求请求时间
    requestQRTimer = now;
}

var fetchTimer = null

// 检测是否是http 强制https
let url = location.href;
if(location.protocol === 'http:') {
    if(location.host.indexOf('yuketang') !== -1 || location.host.indexOf('ykt.io') !== -1) {
      url = url.replace('http:', 'https:').replace('ykt.io', 'www.yuketang.cn');

      location.replace(url);
    }
}

var exampleSocket = null;
var USER = {};
// 判断浏览器是否支持websocket
// https://segmentfault.com/a/1190000002589132
var isSupportWebSocket = !!window.WebSocket && window.WebSocket.prototype.send
console.log(isSupportWebSocket)
if( isSupportWebSocket ) {
    $('#support-socket').show();
    initws();
}else{
    $('#not-support-socket').show();
}

$('.J_year').html(new Date().getFullYear())

function initws() {
    var wsProtocol = location.protocol === 'https:' ? 'wss://' : 'ws://'

    var SOCKET_HOST = location.host
    if (process.env.NODE_ENV !== 'production'){
        // SOCKET_HOST = 'pro.xuetangonline.com'
        SOCKET_HOST = 'pre-apple-ykt.xuetangonline.com'
    }

    if (location.host.indexOf('192.168') != -1 || location.hostname === '127.0.0.1') {
        wsProtocol = 'wss://'
    }

    console.log(SOCKET_HOST, location.host, wsProtocol);

    exampleSocket = new WebSocket(wsProtocol + SOCKET_HOST +'/wsapp/');
    exampleSocket.onclose = function(event){
        console.log('WebSocket onclose');
        // 需要尝试重连
    };

    exampleSocket.onopen = function(event)
    {
        exampleSocket.onmessage = function (event) {
            var msg = JSON.parse(event.data);
            // console.log(msg);

            //获取二维码图片
            if (msg.op == 'requestlogin') {
                $('.loading-icon').hide()
                $('.logma').attr({'src': msg.ticket})
                $('.logma').show()
                qrCode = msg.ticket

                var OLD = new Date().getTime();
                fetchTimer = setInterval(function(){
                    var NOW = new Date().getTime();
                    if(NOW - OLD >= msg.expire_seconds*1000){
                        clearInterval(fetchTimer);
                        fetchMa();
                    }
                }, 1000)
            }

            //扫描登录成功
            if (msg.op == 'loginsuccess') {
                $('.login-success').css({
                    'display': 'flex'
                })
                USER.UserID = msg.UserID;
                USER.Auth = msg.Auth;
                // 验证登录后跳转
                accessLoginApi(function(data){
                    if(data.success){
                        showRain();
                        fetchTimer && clearInterval(fetchTimer);

                        window.localStorage && localStorage.setItem('UserID', msg.UserID);
                        window.localStorage && localStorage.setItem('Auth', msg.Auth);
                    }
                });

                // heartBeat();
            }
        }

        // fetchMa();
        isLogin();
    }
}

// 心跳包
function heartBeat(){
    var timer = setInterval(function(){
        accessLoginApi(function(data){
            if(!data.success){
                $('.J_exit').trigger('click');
            }
        });
    }, 60*1000);
}

// 连接pc_web_login接口
function accessLoginApi(fn){
    if(typeof USER !== 'undefined' && !USER.UserID && window.localStorage) {
        USER.UserID = +localStorage.getItem('UserID');
        USER.Auth = localStorage.getItem('Auth');
    }

    $.ajax({
        url: Api.pc_web_login,
        type: 'post',
        data: JSON.stringify(USER),
        // 后台失败返回不是json格式 需要自己解析下
        dataType: "text",
        success: function (data, status) {
            try{
                let dataJson = JSON.parse(data);
                fn && fn(dataJson);
            } catch (e){
                $('.J_exit').trigger('click');
            }
        },
        error: function (xhr, errorType, error) {
            console.error(error);
        }
    });
}


function GetQueryString(name)
{
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r!=null)return  unescape(r[2]); return null;
}

// 网页版首页显示
function showRain(){
    // 登录成功后清除classroomId以及uv_id 数据 否则可能后续请求会带上这两个参数 导致权限异常
    localStorage && localStorage.removeItem('classroomId')
    localStorage && localStorage.removeItem('uv_id')

    let $next = GetQueryString('next')
    if (GetQueryString('type') && $next) {
        $next = decodeURIComponent($next);

        // 增加新web扫码参数
        if ($next.indexOf('?')>-1) {
            $next += '&date=' + new Date().getTime() + '&newWeb=1'
        } else {
            $next += '?date=' + new Date().getTime() + '&newWeb=1'
        }
        window.location.href = location.origin + $next
    } else {
        if(GetQueryString('old') || ($next && $next != '/v/index')){
            require(['pages/rainpc/rainpc'], function(Rainpc) {
                // 显示雨课堂网页版首页组件
                if(!rainHost.includes(hostKey)){
                    $('body').addClass('body_bg')
                }
                Rainpc.show();
                $('.J_login').hide();

                window.document.title = '雨课堂网页版';
            });
        }else {
            window.location.href = location.origin + '/v2/web'
        }

    }
}

// 检测是否登录
function isLogin(){
    $.ajax({
        url: Api.user_profile,
        type: 'get',
        data: null,
        dataType: "json",
        success: function (data, status) {
            if(data.success){
                // heartBeat();
                window.localStorage && localStorage.setItem('user_profile', JSON.stringify(data.data.user_profile));
                showRain();
            } else {
                if(GetQueryString('share')){
                    $('.mabox').hide()
                    $('.account-box').show()
                    $('.account-box').find('.'+account_type).show()
                }
                fetchMa();
            }
        },
        error: function (xhr, errorType, error) {
            fetchMa();
        }
    });
}

//import $$ from 'jquery'
// 目前版本的jquery只支持beforeunload，zepto不支持unload、beforeunload
// $$(window).on('beforeunload', function(){
//     //关闭网页发送ajax要同步
//     $.ajax({
//         url: Api.pc_web_logout,
//         type: 'get',
//         data: null,
//         dataType: "json",
//         success: function (data, status) {
//         }
//     });
// });
function showQrcode(){
    $('.loading-icon').hide()
    $('.logma').attr({'src': qrCode})
    $('.logma').show()
}


$('body').on('click', '.language', function(){
    $('.J_login').remove()
    if(isEn){
        !rainHost.includes(hostKey) ? $('body').append(loginTplThu) : $('body').append(loginTpl)
    }else {
        !rainHost.includes(hostKey) ? $('body').append(loginTplThuEn) : $('body').append(loginTplEn)
    }
    if( isSupportWebSocket ) {
        $('.support-socket').show();
    }else{
        $('.not-support-socket').show();
    }
    $('.login-box').show()
    $('.mabox').show()
    // clearInterval(fetchTimer)
    // fetchMa()
    showQrcode()

    isEn = !isEn
    !rainHost.includes(hostKey) && setHostInfo()
    setServerInfo()
    account_type = 'phone'

    Cookies.set('django_language', isEn ? 'en' : 'zh-cn')
})

$('body').on('click', '.login_download_tab .tab', function(){
    $('.login_download_tab .tab').removeClass('currentTab')
    let type = $(this).data('type')
    $(this).addClass('currentTab')
    if(type == 'login'){
        $('.login-box').show()
        $('.download-box').hide()
        // clearInterval(fetchTimer)
        // fetchMa()
        showQrcode()
    }else {
        $('.download-box').show()
        $('.login-box').hide()
    }
    resetData()
})

// 默认账号密码设置登录方式 phone：手机 message：短信 email：邮箱

let account_type = 'phone'
let forgetPassword = false
let isAllError = false

// 扫码or账号登录切换
$('body').on('click', '.changeImg', function(){
    if(hostKey=='guangcai' || hostKey=='yudou'){
        return;
    }
    let parent = $(this).closest('div')
    $('.toggle-box').hide()
    $('.form-box').hide()
    if($(parent).data('type') == 'account'){
        $(parent).prev().show()
        // fetchMa()
        showQrcode()
    }else {
        $('.download-box').hide()
        // clearInterval(fetchTimer)
        $(parent).next().show()
        $('.toggle-box').find('.'+account_type).show()
    }
    resetData()
})

// 账号登录切换
$('body').on('click', '.item', function(){
    let type = $(this).data('type')
    $('.item').removeClass('active')
    account_type = type
    $(this).addClass('active')
    $('.content-box .form-box').hide()
    $('.content-box').find('.' + type).show()
    $('.login-btn').addClass('disabled')
    resetData()
    isAllError = false
})

let phoneFlag = false,
    verifyFlag = false,
    passwordFlag = false,
    emailFlag = false,
    confirmFlag = false;

$('body').on('focus', 'input', function(){
    if(!isAllError){
        $(this).closest('.input-box').next().html('')
        $(this).closest('.input-box').addClass('active')
        $(this).closest('.input-box').removeClass('wrong-box')
    }else {
        $('.input-box').next().html('')
        $(this).closest('.input-box').addClass('active')
        $('.input-box').removeClass('wrong-box')
    }
    isAllError = false
})

$('body').on('blur','input[type=mobile]', function(){
    let val = $(this).val()
    if(val){
        if(phonePass(val)){
            phoneFlag = true
        }else {
            phoneFlag = false
            $(this).closest('.input-box').next().html(isEn ? 'Wrong format' : '请输入正确格式手机号')
            $(this).closest('.input-box').addClass('wrong-box')
        }
    }else {
        phoneFlag = false
    }
    if(!forgetPassword){
        if(phoneFlag && (account_type == 'phone' ? passwordFlag : account_type == 'message' ? verifyFlag : '')){
            $('.content-box .login-btn').removeClass('disabled')
        }else {
            $('.content-box .login-btn').addClass('disabled')
        }
    }else {
        if(phoneFlag && verifyFlag && passwordFlag){
            $('.content-box .reset-btn').removeClass('disabled')
        }else {
            $('.content-box .reset-btn').addClass('disabled')
        }
    }
    $(this).closest('.input-box').removeClass('active')
})

$('body').on('keyup', 'input[type=password]', function(){
    let val = $(this).val()
    if(val && val.indexOf(' ') !== -1){
        passwordFlag = false
        $(this).closest('.input-box').next().html(isEn ? 'Password cannot include "space"' : '密码中不能包含空格')
        $(this).closest('.input-box').addClass('wrong-box')
    }

    if(!forgetPassword){
        if(val.length >= 6){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = true
            }else {
                confirmFlag = true
            }
        }else if(val.length < 6 && val){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = false
            }else {
                confirmFlag = false
            }
        }
        if(passwordFlag && (account_type == 'phone' ? phoneFlag : account_type == 'email' ? emailFlag : '')){
            $('.content-box .login-btn').removeClass('disabled')
        }else {
            $('.content-box .login-btn').addClass('disabled')
        }
    }else {
        if(val.length >= 8){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = true
            }else {
                confirmFlag = true
            }
        }else if(val.length < 8 && val){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = false
            }else {
                confirmFlag = false
            }
        }
        if(phoneFlag && verifyFlag && passwordFlag && confirmFlag){
            $('.content-box .reset-btn').removeClass('disabled')
        }else {
            $('.content-box .reset-btn').addClass('disabled')
        }
    }
})
$('body').on('blur','input[type=password]', function(){
    let val = $(this).val()
    if(!forgetPassword){
        if(val.length >= 6){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = true
            }else {
                confirmFlag = true
                if($('input[name=confirm]').val() !== $('input[name=new]').val()){
                    $('.reset-box').find('input[name=confirm]').closest('.input-box').next().html(isEn ? 'Passwords are inconsistent' : '两次输入密码不一致')
                    $(this).closest('.input-box').addClass('wrong-box')
                    return false
                }
            }
        }else if(val.length < 6 && val){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = false
            }else {
                confirmFlag = false
            }
            $(this).closest('.input-box').next().html(isEn ? 'Less than 6 characters' : '请输入6位及以上密码')
            $(this).closest('.input-box').addClass('wrong-box')
        }
        if(passwordFlag && (account_type == 'phone' ? phoneFlag : account_type == 'email' ? emailFlag : '')){
            $('.content-box .login-btn').removeClass('disabled')
        }else {
            $('.content-box .login-btn').addClass('disabled')
        }
    }else {
        if(val.length >= 8){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = true
            }else {
                confirmFlag = true
                if($('input[name=confirm]').val() !== $('input[name=new]').val()){
                    $('.reset-box').find('input[name=confirm]').closest('.input-box').next().html(isEn ? 'Passwords are inconsistent' : '两次输入密码不一致')
                    $(this).closest('.input-box').addClass('wrong-box')
                    return false
                }
            }
        }else if(val.length < 8 && val){
            if($(this).attr('name') !== 'confirm'){
                passwordFlag = false
            }else {
                confirmFlag = false
            }
            $(this).closest('.input-box').next().html(isEn ? 'Less than 8 characters' : '请输入8位及以上密码')
            $(this).closest('.input-box').addClass('wrong-box')
        }
        if(phoneFlag && verifyFlag && passwordFlag && confirmFlag){
            $('.content-box .reset-btn').removeClass('disabled')
        }else {
            $('.content-box .reset-btn').addClass('disabled')
        }
    }
    $(this).closest('.input-box').removeClass('active')
})


$('body').on('blur', 'input[type=email]',function(){
    let val = $(this).val()
    if(val){
        if(emailPass(val)){
            emailFlag = true
        }else {
            emailFlag = false
            $(this).closest('.input-box').next().html(isEn ? 'Wrong format' : '请输入正确格式的邮箱')
            $(this).closest('.input-box').addClass('wrong-box')
        }
    }else {
        emailFlag = false
    }
    if(emailFlag && passwordFlag){
        $('.content-box .login-btn').removeClass('disabled')
    }else {
        $('.content-box .login-btn').addClass('disabled')
    }
    $(this).closest('.input-box').removeClass('active')
})
$('body').on('keyup','input[type=text]', function(){
    let val = $(this).val()
    if(val && val.length == 6){
        verifyFlag = true
    }else {
        verifyFlag = false
    }
    if(!forgetPassword){
        if(verifyFlag && phoneFlag){
            $('.content-box .login-btn').removeClass('disabled')
        }else {
            $('.content-box .login-btn').addClass('disabled')
        }
    }else {
        if(phoneFlag && verifyFlag && passwordFlag){
            $('.content-box .reset-btn').removeClass('disabled')
        }else {
            $('.content-box .reset-btn').addClass('disabled')
        }
    }

})
$('body').on('blur','input[type=text]', function(){
    let val = $(this).val()
    if(val && val.length == 6){
        verifyFlag = true
    }else {
        verifyFlag = false
    }
    if(!forgetPassword){
        if(verifyFlag && phoneFlag){
            $('.content-box .login-btn').removeClass('disabled')
        }else {
            $('.content-box .login-btn').addClass('disabled')
        }
    }else {
        if(phoneFlag && verifyFlag && passwordFlag){
            $('.content-box .reset-btn').removeClass('disabled')
        }else {
            $('.content-box .reset-btn').addClass('disabled')
        }
    }
    $(this).closest('.input-box').removeClass('active')
})

$('body').on('keydown', '.content-box .form-item:last-child input', function(e){
    if(e.keyCode == 13){
        if(forgetPassword){
            $('.reset-btn').click()
        }else {
            $('.login-btn').click()
        }
    }
})

// 验证手机号
function phonePass(val){
    let TEL_REGEXP = /^1[3456789]\d{9}$/;
    if(!TEL_REGEXP.test(val)){
        return false
    }else {
        return true
    }
}

function emailPass(val){
    let EMAIL_REGEXP = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
    if(!EMAIL_REGEXP.test(val)){
        return false
    }else {
        return true
    }
}

// 300401 错误的邮箱格式
// 300402 错误的手机号格式
// 300403 邮箱已被绑定
// 300404 验证码已过期
// 300405 错误的验证码
// 300406 错误的旧密码
// 300407 无效的新密码
// 300408 短信验证码发送失败
// 300409 不存在的用户
// 300410 错误的登录密码
// 300411 错误的登录类型
// 300412 用户名或密码不正确    //此为新增的  后续300409以及300410统一返回300412

// 登录
$('body').on('click', '.login-btn', function(){
    let canSubmit = false
    let params = {
        type: 'PP',
        name: $('.content-box').find('.' + account_type).find('input[name=loginname]').val(),
        pwd: $('.content-box').find('.' + account_type).find('input[type=password]').val(),
    }
    switch(account_type){
        case 'phone':
            canSubmit = phoneFlag && passwordFlag ? true : false
            params.pwd = encryptor.encrypt(params.pwd)
            params.type = 'PP'
            break;
        case 'message':
            canSubmit = phoneFlag && verifyFlag ? true : false
            params.pwd = $('.content-box').find('.' + account_type).find('input[type=text]').val()
            params.type = 'PC'
            break;
        case 'email':
            canSubmit = emailFlag && passwordFlag ? true : false
            params.pwd = encryptor.encrypt(params.pwd)
            params.type = 'E'
            break
    }
    if(!canSubmit) return false

    if(account_type !== 'message') {
        handleCaptcha().then(res => {
            if(res.ticket) {
                params.ticket = res.ticket
                params.randstr = res.randstr
                handleLoginRequest(params)
            }

        }).catch(err => {
            let {ticket, randstr} = loadErrorCallback()
            params = Object.assign({}, params, {
                hcaptcha_token: '',
                ticket,
                randstr
            })
            hcaptchas(false, params)
        })
    }else {
        handleLoginRequest(params)
    }


})


function handleLoginRequest(params) {
    $.ajax({
        url: Api.user_account_setting.verify_pwd_login,
        type: 'post',
        data: JSON.stringify(params),
        contentType: 'application/json',
        dataType: "json",
        success: function (data, status) {
            if(data.success){
                showRain()
            } else {
                switch(data.status_code){
                    case 300401:
                    case 300403:
                        $('.'+account_type).find('input[type=email]').closest('.input-box').next().html(data.msg)
                        $('.'+account_type).find('input[type=email]').closest('.input-box').addClass('wrong-box')
                        break;
                    case 300402:
                        $('.'+account_type).find('input[type=mobile]').closest('.input-box').next().html(data.msg)
                        $('.'+account_type).find('input[type=mobile]').closest('.input-box').addClass('wrong-box')
                        break;
                    case 300404:
                    case 300405:
                    case 300408:
                        $('.'+account_type).find('input[type=text]').closest('.input-box').next().html(data.msg)
                        $('.'+account_type).find('input[type=text]').closest('.input-box').addClass('wrong-box')
                        break;
                    case 300409:
                        if(account_type !== 'email'){
                            $('.'+account_type).find('input[type=mobile]').closest('.input-box').next().html(data.msg)
                            $('.'+account_type).find('input[type=mobile]').closest('.input-box').addClass('wrong-box')
                        }else {
                            $('.'+account_type).find('input[type=email]').closest('.input-box').next().html(data.msg)
                            $('.'+account_type).find('input[type=email]').closest('.input-box').addClass('wrong-box')
                        }
                        break;
                    case 300410:
                        $('.'+account_type).find('input[type=password]').closest('.input-box').next().html(data.msg)
                        $('.'+account_type).find('input[type=password]').closest('.input-box').addClass('wrong-box')
                        break;
                    case 300412:
                        if(account_type !== 'email'){
                            $('.'+account_type).find('input[type=mobile]').closest('.input-box').addClass('wrong-box')
                        }else {
                            $('.'+account_type).find('input[type=email]').closest('.input-box').addClass('wrong-box')
                        }
                        $('.'+account_type).find('input[type=password]').closest('.input-box').next().html(data.msg)
                        $('.'+account_type).find('input[type=password]').closest('.input-box').addClass('wrong-box')
                        isAllError = true
                        break;
                }
            }
        },
        error: function (xhr, errorType, error) {

        }
    });
}

// 忘记密码
$('body').on('click', '.forget-password span', function(){
    $('.account-box').hide()
    $('.reset-box').show()
    $('.reset-box .form-box').show()
    forgetPassword = true
    resetData()
})

$('body').on('click', '.close-reset', function(){
    $('.reset-box').hide()
    $('.account-box').show()
    forgetPassword = false
    resetData()
})

// 短信登录获取验证码
let countDown = 60,
    countDownTimer = null,
    isCountDown = false;

$('body').on('click', '.content-box .verify_code', function(){
    let self = $(this)
    let type = $(this).data('type')
    let mobile = $(this).closest('.form-box').find('input[type=mobile]').val()
    let params = {
        mobile: mobile,
        login: type !== 'reset' ? true : false
    }
    if(isCountDown || !mobile) return
    preSend(mobile, type !== 'reset' ? true : false).then(res => {
        isCountDown = true
        handleCountDown($(self))
    }).catch(error => {
        console.log('rquest error', error)
        switch(error.status_code){
            case 300401:
            case 300403:
                $('.'+account_type).find('input[type=email]').closest('.input-box').next().html(error.msg)
                $('.'+account_type).find('input[type=email]').closest('.input-box').addClass('wrong-box')
                break;
            case 300402:
                $('.'+account_type).find('input[type=mobile]').closest('.input-box').next().html(error.msg)
                $('.'+account_type).find('input[type=mobile]').closest('.input-box').addClass('wrong-box')
                break;
            case 300404:
            case 300405:
            case 300408:
                $('.'+account_type).find('input[type=text]').closest('.input-box').next().html(error.msg)
                $('.'+account_type).find('input[type=text]').closest('.input-box').addClass('wrong-box')
                break;
            case 300409:
                if(forgetPassword || account_type !== 'email'){
                    if(forgetPassword){
                        $('.reset-box').find('input[type=mobile]').closest('.input-box').next().html(error.msg)
                        $('.'+account_type).find('input[type=mobile]').closest('.input-box').addClass('wrong-box')
                    }else {
                        $('.'+account_type).find('input[type=mobile]').closest('.input-box').next().html(error.msg)
                        $('.'+account_type).find('input[type=mobile]').closest('.input-box').addClass('wrong-box')
                    }
                }else {
                    $('.'+account_type).find('input[type=email]').closest('.input-box').next().html(error.msg)
                    $('.'+account_type).find('input[type=email]').closest('.input-box').addClass('wrong-box')
                }
                break;
            case 300410:
                $('.'+account_type).find('input[type=password]').closest('.input-box').next().html(error.msg)
                $('.'+account_type).find('input[type=password]').closest('.input-box').addClass('wrong-box')
                break;
            case 300412:
                $('input[type=text]').closest('.input-box').next().html(error.msg)
                $('input[type=text]').closest('.input-box').addClass('wrong-box')
                break;
            case 300415:
                $('input[type=text]').closest('.input-box').next().html(isEn ? 'Verification Code has sent，please try later.' : '验证码已发送，请稍后再试。')
                $('input[type=text]').closest('.input-box').addClass('wrong-box')
                break;
        }
    })
})

// 发送验证码前，做一次水墙验证
function preSend(phone_number, isLogin) {
    return new Promise((resolve, reject) => {
        const appid = '2091064951'
        handleCaptcha().then(res => {
            const { randstr, ret, ticket, errorCode } = res
            if(ticket) {
                let params = {
                    randstr,
                    ticket,
                    mobile: phone_number,
                    login: isLogin,
                    hcaptcha_token: ''
                }
                resolve(sendCode(params))
            }

        }).catch(err => {
            let { randstr,ticket } = loadErrorCallback()
            let params = {
                mobile: phone_number,
                login: isLogin,
                hcaptcha_token: '',
                randstr,
                ticket,
            }
            resolve(hcaptchas(true, params))
        })
    })
}

function sendCode(params){
    return new Promise((resolve, reject) => {
        const url = Api.user_account_setting.send_sms_login_code;

        request.post(url, params).then(res => {
            console.log('result',res)
            if(res.success){
                console.log('验证码发送成功', res);
                resolve(res)
            }else {
                console.log('验证码发送失败', res);
                reject(res)
            }
        }).catch(e => {
            console.log('验证码发送失败', e);
            reject(e)
        })
    })

}

function handleCountDown(ele){
    countDownTimer = setInterval(() => {
        if(countDown > 0){
            countDown--
            $(ele).html(countDown+'s')
        }else {
            clearInterval(countDownTimer)
            countDown = 60
            $(ele).html(isEn ? 'Get' : '获取验证码')
            isCountDown = false
        }

    }, 1000)
}

function handleCaptcha(callback){
    return new Promise((resolve, reject) => {
        const appid = '2091064951'
        const tc = new TencentCaptcha(appid, res => {
            const { randstr, ret, ticket, errorCode } = res
            console.log(res)
            if(ret === 0 && ticket && !errorCode) {
                resolve(res)
            }else if(ret == 2){
                // 用户主动关闭
                resolve(res)
            }else {
                reject(res)
            }
        }, {
            userLanguage: Cookies.get('django_language') == 'en' ? 'en' : 'zh-cn'
        })
        tc.show();

      })
}

function loadErrorCallback() {
    var CaptchaAppId = '2091064951'
    var ticket = 'terror_1001_' + CaptchaAppId + '_' + Math.floor(new Date().getTime() / 1000);
    return {
      ret: 0,
      randstr: '@'+ Math.random().toString(36).substr(2),
      ticket: ticket,
      errorCode: 1001,
      errorMessage: 'jsload_error',
    };
  }

function hcaptchas (isSendCode, params) {
    return new Promise((resolve, reject) => {
        //获取id
        var widgetID = hcaptcha.render('h-captcha', { sitekey: '50f6f060-c606-4e3b-b6e8-ca3b706b61e1' })
        //异步反馈是否成功
        hcaptcha.execute(widgetID, { async: true })
        .then(({ response, key }) => {
            if(isSendCode) {
                params.hcaptcha_token = response
                resolve(sendCode(params))
            }else {
                params.hcaptcha_token = response
                resolve(handleLoginRequest(params))
            }
        })
        .catch(err => {
            console.log('fail', err);
            reject(err)
        });
    })

};
// 找回密码
$('body').on('click', '.reset-btn', function(){
    if($('input[name=confirm]').val() !== $('input[name=new]').val()){
        $('.reset-box').find('input[name=confirm]').closest('.input-box').next().html(isEn ? 'Passwords are inconsistent' : '两次输入密码不一致')
        $('.reset-box').find('input[name=confirm]').closest('.input-box').addClass('wrong-box')
        return false
    }
    let canSubmit = phoneFlag && verifyFlag && passwordFlag
    let params = {
        phone: $('.reset-box input[type=mobile]').val(),
        pwd: encryptor.encrypt($('.reset-box input[type=password]').val()),
        code: $('.reset-box input[type=text]').val()
    }
    if(!canSubmit) return false
    $.ajax({
        url: Api.user_account_setting.set_forgotten_password,
        type: 'post',
        data: JSON.stringify(params),
        dataType: "json",
        success: function (data, status) {
            if(data.success){
                $('.reset-success').addClass('toast')
                setTimeout(() => {
                    $('.reset-success').removeClass('toast')
                    $('.reset-box').hide()
                    $('.account-box').show()
                    forgetPassword = false
                    clearInterval(countDownTimer)
                    $('.reset-box .verify_code').html(isEn ? 'Get' : '获取验证码')
                    resetData()
                }, 2500)

            } else {
                switch(data.status_code){
                    case 300404:
                    case 300405:
                        $('.reset-box').find('input[type=text]').closest('.input-box').next().html(data.msg)
                        $('.reset-box').find('input[type=text]').closest('.input-box').addClass('wrong-box')
                        break;
                    case 300409:
                        $('.reset-box').find('input[type=mobile]').closest('.input-box').next().html(data.msg)
                        $('.reset-box').find('input[type=mobile]').closest('.input-box').addClass('wrong-box')
                        break;
                    case 300407:
                        $('.reset-box').find('input[type=password]').closest('.input-box').next().html(data.msg)
                        $('.reset-box').find('input[type=password]').closest('.input-box').addClass('wrong-box')
                        break;
                    case 300414:
                        $('.reset-box').find('input[type=password]').closest('.input-box').next().html(isEn ? 'Wrong password format' : '密码格式错误')
                        $('.reset-box').find('input[type=password]').closest('.input-box').addClass('wrong-box')
                        break;
                }
            }
        },
        error: function (xhr, errorType, error) {

        }
    });
})

function resetData(){
    phoneFlag = false
    verifyFlag = false
    passwordFlag = false
    emailFlag = false
    $('input').val('')
    $('.input-box').removeClass('active')
    $('.input-box').removeClass('wrong-box')
    $('.input-box').next().html('')
    clearInterval(countDownTimer)
    $('.verify_code').html(isEn ? 'Get' : '获取验证码')
    isCountDown = false
    countDown = 60
}

$('body').on('mouseover', '.help', function(){
    $('.phone-tip').show()
})
$('body').on('mouseout', '.help', function(){
    $('.phone-tip').hide()
})


// 统计
setTimeout(()=>{
    // pv单页面统计
    typeof dailyReport !== 'undefined' && dailyReport.reportLog();
}, 2000);



// WEBPACK FOOTER //
// ./src/pages/login/login.js